
import { connect } from "react-redux";
import { Portfolio } from "./Portfolio";
import { loadPortfolio } from "../../superadmin/portfolio-reducer";
import { loadUserQueueItems } from "../../superadmin/notification-reducer";

const mapDispatchToProps = dispatch => {
  return {
    loadPortfolio: (username, index) => dispatch(loadPortfolio(username, index)),
    loadUserQueueItems: (username, index, queue_type) => dispatch(
      loadUserQueueItems(username, index, queue_type)),
  };
}

const mapStateToProps = state => {
  return {
    portfolio: state.portfolio,
    client: state.client,
    notification: state.notification,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
